import { FC, memo } from 'react';
import {
  As,
  Box,
  BoxProps as ChakraBoxProps,
  Button,
  Center,
  HStack,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react';

import cn from 'classnames';
import isEqual from 'lodash/fp/isEqual';
import styles from './Achievement.module.scss';
import { getDataTracking } from '../../utils';

export interface AchievementProps extends ChakraBoxProps {
  actionTitle?: string;
  description: string;
  href?: string;
  icon: As;
  isComplete?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  title: string;
}

export const Achievement: FC<AchievementProps> = memo(
  ({
    actionTitle,
    description,
    href,
    icon,
    isComplete = false,
    isLoading = false,
    onClick,
    title,
    ...rest
  }: AchievementProps) => (
    <Box
      w="full"
      p={4}
      className={cn(styles.achievement, {
        [styles.complete]: isComplete,
      })}
      {...rest}
    >
      <VStack w="full">
        <HStack w="full">
          <Center>
            <Box pr={3}>
              <Icon as={icon} />
            </Box>
            <Box flex="1">
              <Text fontSize={18} align="left">
                {title}
              </Text>
              <Text fontSize={12} align="left">
                {description}
              </Text>
            </Box>
          </Center>
        </HStack>

        {!!actionTitle && !isComplete && (
          <Button
            w="100%"
            size="sm"
            colorScheme="blue"
            onClick={onClick}
            isLoading={isLoading}
            {...getDataTracking(`achievement${actionTitle}`)}
            {...(href
              ? {
                  as: 'a',
                  href,
                  type: 'button',
                }
              : undefined)}
          >
            {actionTitle}
          </Button>
        )}
      </VStack>
    </Box>
  ),
  isEqual
);
